/**
 * Standard opt-out message text to be used across the application
 *
 * KUDOSITY SYSTEM (Current):
 * - We send: \n\n[unsub-reply-link] (20 chars)
 * - Kudosity replaces [unsub-reply-link] (18 chars) with UnsubRep.ly/xxxxxxxx (20 chars)
 * - Customer receives: \n\n + 20 char link = 22 chars total
 *
 * LEGACY SYSTEM (Previous):
 * - We send: \n\nReply STOP to opt-out (23 chars)
 * - Customer receives: \n\nReply STOP to opt-out (23 chars)
 *
 * Format: Two newlines before, no newline after (matches backend)
 *
 * IMPORTANT: This uses the Kudosity parameter [unsub-reply-link], NOT a hardcoded link.
 * This constant is 20 chars sent, but customer receives 22 chars after Kudosity replacement.
 *
 * NOTE: Backend feature flag USE_KUDOSITY_OPT_OUT_LINK controls actual behavior.
 * To revert to legacy, backend sets flag to 'false' and frontend would need update.
 */
export const OPT_OUT_MESSAGE = "\n\n[unsub-reply-link]"; // 20 chars sent

/**
 * Get the actual character count that customers receive
 * Accounts for Kudosity's dynamic link replacement
 *
 * - Kudosity: We send [unsub-reply-link] (18 chars) but Kudosity replaces
 *   with UnsubRep.ly/xxxxxxxx (20 chars), so customer receives +2 chars more
 * - Total received: 2 newlines + 20 char link = 22 characters
 *
 * @returns The number of characters customers actually receive
 */
export const getOptOutReceivedLength = (): number => {
  // [unsub-reply-link] = 18 chars, Kudosity replaces with 20-char link
  // Total: 2 newlines + 20 char link = 22 chars
  return 22;
};

/**
 * Converts snake_case variables to space-separated format for EZITXT compatibility
 * @param variable The variable name in snake_case
 * @returns The variable name with spaces
 */
export function formatPersonalizationVariable(variable: string): string {
  // If already has spaces, return as is
  if (variable.includes(' ')) return variable;
  
  // If it's snake_case, replace underscores with spaces
  if (variable.includes('_')) {
    return variable.replace(/_/g, ' ');
  }
  
  // If it's camelCase, add spaces before capital letters
  return variable.replace(/([A-Z])/g, ' $1').toLowerCase().trim();
}

/**
 * Formats a personalization variable with proper formatting and brackets
 * @param variable The variable name (without brackets)
 * @returns Formatted variable with brackets and proper spacing
 */
export function formatVariable(variable: string): string {
  let formattedVar = variable;
  
  // Remove any existing brackets
  formattedVar = formattedVar.replace(/[{}]/g, '');
  
  // Format the variable with spaces
  formattedVar = formatPersonalizationVariable(formattedVar);
  
  return `{${formattedVar}}`;
}
